<template>
  <v-chip
    ripple
    :variant="chipVariant"
    :prepend-icon="assetContainerStatusIcon"
    :color="assetContainerStatusColor">
    {{ title }}
  </v-chip>
</template>
<script>
import { computed, defineComponent } from 'vue';
import useYard from '../../composables/useYard';
import { AssetContainerEventType } from '@nova/core';

export default defineComponent({
  name: 'YardViewAssetContainerStatusChip',
  props: {
    value: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    }
  },
  setup(props) {
    const yardStore = useYard();

    const chipVariant = computed(() => {
      const outlinedStatuses = [
        AssetContainerEventType.Arrived,
        AssetContainerEventType.Loading,
        AssetContainerEventType.Unloading
      ];
      return outlinedStatuses.includes(props.value) ? 'outlined' : 'tonal';
    });

    const assetContainerStatusIcon = computed(() => {
      return yardStore.getAssetContainerStatusIcon(props.value);
    });

    const assetContainerStatusColor = computed(() => {
      return yardStore.getAssetContainerStatusColor(props.value);
    });

    return {
      assetContainerStatusColor,
      chipVariant,
      assetContainerStatusIcon
    };
  }
});
</script>
